/* jshint node:true */
'use strict';

var debug   = require('debug')('app:action:loadLeagues');
var apiHost = require('../helpers/utils/apiHost.js');

module.exports = function(context,payload,done) {

    /* build api based on sport */
    var sAPIHost    = apiHost.get(payload);
    var sUrl        = sAPIHost+'/apis/site/v2/leagues/dropdown';
    var aApiParams  = [];

    if(payload.sport === 'soccer'){
        aApiParams.push('ceId='+12032789);
    }else{
        aApiParams.push('sport='+payload.sport);
    }

    /* add params if found */
    if(aApiParams.length > 0){
        sUrl = sUrl+'?'+aApiParams.join('&');
    }

    debug('sUrl %s', sUrl);

    context.service.get({
        url : sUrl,
        done : function(data) {

            var oData = {
                data:data
            };

            context.dispatch('RECEIVED_LEAGUES', oData);
            done();
        }
    });

};



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/actions/loadLeagues.js
 **/